<template>
  <b-card title="Add Counter">
      <b-col cols="12">
        <b-button
          size="md"
          variant="primary"
          @click="$router.go(-1)"
          v-if="goBack !== 'other'"
          >Back</b-button
        >
      </b-col>

      <b-col cols="12">
          <label>
              Name<span style="color:red">(*)</span>
          </label>

          <b-form-input
              v-model="form.name" placeholder="Name">
          </b-form-input>
      </b-col>

      <b-col cols="12">
          <label>Location<span style="color:red">(*)</span></label>
          <b-form-input disabled placeholder="Location" v-model="form.warehouse"></b-form-input>
      </b-col>

      <b-col cols="12" class="mt-2">
          <label>Counter can process<span style="color:red">(*)</span></label>
          <div>
            <b-form-checkbox v-model="isAll" @change="handleAllChange">ALL</b-form-checkbox>
          </div>
          <div >
            <b-form-checkbox :disabled="isAll"  v-model="ekr" @change="handleProcessChange">EKR - Online Dealer</b-form-checkbox>
            <b-form-checkbox :disabled="isAll" v-model="ekc" @change="handleProcessChange">EKC - Walk In Cash Sales</b-form-checkbox>
            <b-form-checkbox :disabled="isAll" v-model="eko" @change="handleProcessChange">EKO - Online Cash Sales</b-form-checkbox>
          </div>
      </b-col>

      <b-col cols="12" class="mt-2">
          <b-button variant="success" @click="submitCounter">Add</b-button>
      </b-col>
  </b-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
      return {
          form: {
            name:"",
            warehouse:"",
            canProcess: ["ALL"]
          },
          isAll: true,
          ekr: false,
          ekc: false,
          eko: false
      }
  },
  mounted() {
      // this.getCategories();
      var location = ['daikin'];
      if(!location.includes(this.$route.params.warehouse)){

      }

      this.form.warehouse=this.$route.params.warehouse
  },
  methods: {
    ...mapActions({
      addCounter: "counter/addCounter",
    }),
    handleAllChange(checked) {
      if (checked) {
        this.form.canProcess = ["ALL"];
        this.ekr = false;
        this.ekc = false;
        this.eko = false;
      } else {
        this.form.canProcess = [];
      }
    },
    handleProcessChange() {
      this.form.canProcess = [];
      if (this.ekr) this.form.canProcess.push("EKR");
      if (this.ekc) this.form.canProcess.push("EKC");
      if (this.eko) this.form.canProcess.push("EKO");
      
      // If no options selected, default to ALL
      if (this.form.canProcess.length === 0) {
        this.isAll = true;
        this.form.canProcess = ["ALL"];
      }
    },
    submitCounter() {
      this.addCounter(this.form).then((res) => {
        this.$bvToast.toast(`Counter added successfully`, {
          title: "Success",
          variant: "success",
          solid: true,
        })
        this.$router.go(-1);
      }).catch((err) => {
        console.error(err)
        this.$bvToast.toast(`${err.response.data.errors[0].message}`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        })
      })
    }
      
  },
  computed: {
  }
}
</script>